import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookiesComponent } from './components/cookies/cookies.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CookiesComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'orego';
}
